export const WRAPPED_MARKDOWN_KEY = '__wrappedMd__';
